'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // List of errors that fades away after being shown.


var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReservationErrorsController = function () {
    function ReservationErrorsController($scope, $timeout) {
        _classCallCheck(this, ReservationErrorsController);

        this.show = 'hidden';
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.errorLocation = 'top-error';
    }

    _createClass(ReservationErrorsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.$on(this.errorEvent || 'winresReservationShowErrors', function (event, errors, location) {
                _this.errors = _.cloneDeep(errors);
                _this.location = _.cloneDeep(location);
                if (_this.location == 'bottom-error') {
                    _this.errorLocation = _this.location;
                }

                if (_this.errors.length > 5) {
                    _this.errors.length = 5;
                }

                _this.showErrors = 'visible';

                if (!_this.errorTimeout) {
                    _this.errorTimeout = 2000;
                }

                if (_this.error !== undefined) {
                    _this.$timeout.cancel(_this.error);
                }

                if (_this.hideError !== undefined) {
                    _this.$timeout.cancel(_this.hideError);
                }

                _this.error = _this.$timeout(function () {
                    if (_this.showErrors !== 'hidden') {
                        _this.showErrors = 'fading';
                        _this.hideError = _this.$timeout(function () {
                            _this.showErrors = 'hidden';
                            if (_this.location == 'bottom-error') {
                                _this.errorLocation = 'top-error';
                            }
                        }, 1000);
                    }
                }, _this.errorTimeout);
            });
        }
    }, {
        key: 'Close',
        value: function Close() {
            this.showErrors = 'hidden';

            if (this.error !== undefined) {
                this.$timeout.cancel(this.error);
            }

            if (this.hideError !== undefined) {
                this.$timeout.cancel(this.hideError);
            }
        }
    }]);

    return ReservationErrorsController;
}();

ReservationErrorsController.$inject = ['$scope', '$timeout'];

_module3.default.component('reservationErrors', {
    template: require('./reservationErrors.html'),
    controller: ReservationErrorsController,
    require: {},
    bindings: {
        errorTimeout: '@',
        errorEvent: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/reservationErrors/reservationErrors.js
// module id = 276
// module chunks = 2